<div *ngIf="exibir" class="loader">
    <div id="loader-wrapper">
        <div id="loader"></div>
    </div>
</div>
<div class="blocker" *ngIf="exibir"></div>